<script setup lang="ts">
import { useTranslation } from '@/plugins/i18n/useTranslation';

export type ChipProps = {
  color?: string;
  variant?: 'outlined' | 'elevated' | 'text' | 'plain';
  dataCy?: string;
  rounded?: boolean;
  density?: 'x-small' | 'small' | 'default' | 'large' | 'x-large';
  text?: string;
  onClick?: (e: MouseEvent | KeyboardEvent) => void;
};

const { t } = useTranslation();

const props = defineProps<ChipProps>();

function onClicked(e: MouseEvent | KeyboardEvent) {
  if (props.onClick) {
    props.onClick(e);
  }
}
</script>

<template>
  <v-chip
    class="chip"
    :variant="props.variant"
    :color="props.color || 'neutral'"
    :data-cy="props.dataCy"
    :size="props.density"
    :class="{ squared: !props.rounded }"
    @click="onClicked"
  >
    <slot>{{ t(props.text || '') }}</slot>
  </v-chip>
</template>
<style scoped lang="scss">
.v-chip.squared {
  border-radius: 0 !important;
}
</style>
